import { Link } from 'react-router-dom';

export function LegalPageShell({
  title,
  version,
  children,
}: {
  title: string;
  version: string;
  children: React.ReactNode;
}) {
  return (
    <div className="min-h-screen bg-manejai-cream/40">
      <div className="mx-auto max-w-3xl px-6 py-10">
        <p className="text-sm text-manejai-bark/60">
          <Link to="/login" className="text-manejai-moss hover:underline">
            Manejai
          </Link>
          {' · '}
          Documento legal
        </p>
        <h1 className="mt-4 font-display text-3xl font-semibold text-manejai-forest">{title}</h1>
        <p className="mt-2 text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-lg px-4 py-3">
          Rascunho v{version} — em revisão jurídica. Não substitui assessoria legal.
        </p>
        <article className="prose prose-sm mt-8 max-w-none text-manejai-bark/90 space-y-4">
          {children}
        </article>
        <p className="mt-10 text-center text-sm text-manejai-bark/60">
          <Link to="/privacidade" className="text-manejai-moss hover:underline" target="_blank" rel="noopener noreferrer">
            Política de Privacidade
          </Link>
          {' · '}
          <Link to="/termos" className="text-manejai-moss hover:underline" target="_blank" rel="noopener noreferrer">
            Termos de Uso
          </Link>
          {' · '}
          <Link to="/cadastro" className="text-manejai-moss hover:underline">
            Criar conta
          </Link>
        </p>
      </div>
    </div>
  );
}
